import { Component, signal } from '@angular/core';

import { throwError } from 'rxjs';

import { UploadComponent } from '@camelot/form-input';
import { InputUpload } from '@camelot/form-model';
import { NotificationBoxComponent } from '@camelot/notification';
import { CamDocumentsService } from '@camelot/services';

import { TestIdDirective } from '@camelot/testing-harness';

export const errorFlowSpy = {
  failedCalls: signal(0),
};

const failingDocumentsServiceMock = {
  addDocument$: () => {
    errorFlowSpy.failedCalls.update(count => count + 1);
    return throwError(() => new Error('upload failed'));
  },
  documents: { get$: () => throwError(() => new Error('fetch failed')) },
  fetchDocuments$: () => throwError(() => new Error('fetch failed')),
  getDocuments$: () => throwError(() => new Error('fetch failed')),
};

@Component({
    imports: [NotificationBoxComponent, TestIdDirective, UploadComponent],
    providers: [{ provide: CamDocumentsService, useValue: failingDocumentsServiceMock }],
    template: `
    <cam-notification-box camTestId="ef-box" />
    <cam-input-upload
      camTestId="ef-upload"
      [input]="this.upload"
      [standalone]="true"
      (uploadStatusChanged)="this.lastStatus.set($event ? 'uploading' : 'idle')"
    />
    <div camTestId="ef-failed-calls">{{ this.failedCalls() }}</div>
    <div camTestId="ef-status">{{ this.lastStatus() }}</div>
  `
})
export class ErrorFlowsCase {
  public failedCalls = errorFlowSpy.failedCalls;
  public lastStatus = signal('idle');
  public upload = new InputUpload({ key: 'upload', label: 'Upload' });
}
